export const BytesPerMegaByte = 1024 * 1024;

export const UploadUsage = {
  Image: 'image',
  Attachment: 'attachment',
  CsvImport: 'csvimport',
} as const;

export type UploadUsageType = (typeof UploadUsage)[keyof typeof UploadUsage];

export const UploadMaxFileSizes = {
  image: 3 * BytesPerMegaByte, // 3MiB
  attachment: 5 * BytesPerMegaByte, // 5MiB
  csvimport: 250 * BytesPerMegaByte, // 250MiB
};
